import React from 'react';
import { useBailleursDossierReadQueryPromise } from 'common-app/api/query/dossier-read';
import { useDocumentalValidationRelatedReadQueryPromise, } from '@isyc-react/oc-api/queries/documental';
import { DossierDocuments } from './dossier-documents.component';
import { Spinner } from '@isyc-react/design/bootstrap';
import { docGroupToCompletedAndPending } from './doc-group';
import { useParams } from 'react-router-dom';
export const DossierDocumentsContainer = () => {
    var _a;
    const { dossierId } = useParams();
    const dossierRead = useBailleursDossierReadQueryPromise();
    const getDocGroupValidation = useDocumentalValidationRelatedReadQueryPromise();
    const [loading, setLoading] = React.useState(true);
    const [dossier, setDossier] = React.useState(null);
    const [docs, setDocs] = React.useState(null);
    const getGroupValidation = React.useCallback(() => {
        dossierRead({ dossierId: dossierId ? parseInt(dossierId) : undefined }).then(result => {
            var _a;
            const dossier = result.data.bailleurs_dossier_read;
            const promises = [];
            promises.push(getDocGroupValidation({ relatedId: dossier.id, relatedObjectTypeId: 1415 }));
            (_a = dossier.participants) === null || _a === void 0 ? void 0 : _a.forEach(p => promises.push(getDocGroupValidation({ relatedId: p.id, relatedObjectTypeId: 1412 })));
            Promise.all(promises).then(res => {
                var _a, _b;
                const [resDossier, ...resParticipants] = res;
                const documentals = {
                    completed: [],
                    pending: [],
                };
                const item = docGroupToCompletedAndPending(resDossier.data.documentalValidation_read_byRelated, dossier.id, 1415, (_a = dossier.name) !== null && _a !== void 0 ? _a : '');
                documentals.completed.push(...item.completed);
                documentals.pending.push(...item.pending);
                (_b = dossier.participants) === null || _b === void 0 ? void 0 : _b.forEach((p, i) => {
                    const item = docGroupToCompletedAndPending(resParticipants[i].data.documentalValidation_read_byRelated, p.id, 1412, p.name);
                    documentals.completed.push(...item.completed);
                    documentals.pending.push(...item.pending);
                });
                setDossier(dossier);
                setDocs(documentals);
                setLoading(false);
            });
        });
    }, []);
    React.useEffect(() => {
        setLoading(true);
        getGroupValidation();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null, docs && dossier && !loading ? (React.createElement(React.Fragment, null,
            React.createElement(DossierDocuments, { docs: docs, businessUnitId: (_a = dossier.businessUnitId) !== null && _a !== void 0 ? _a : 0, onUpload: () => {
                    getGroupValidation();
                } }))) : (React.createElement("div", { className: 'd-flex justify-content-center align-items-center mb-4' },
            React.createElement(Spinner, { animation: 'border' }))))));
};
